import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Paper, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, MenuItem, } from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import TextField from '@mui/material/TextField';
import { useMessage } from '../../context/message-context';
import Page from '../shared/components/PageComponent';
import Layout from '../shared/components/LayoutComponent';
function MandatoryDocument(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState(localStorage.getItem("WEBPDB_FILTER") ? localStorage.getItem("WEBPDB_FILTER") : "O");
  const [searchFilter, setSearchFilter] = useState("");

  const { hideMessage, showErrorMessage } = useMessage();
  const ladeDocuments = () => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "WEBPDB",
      "statement": "LESEN",
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, documentCb);
  }
  useEffect(() => {
    ladeDocuments()
    // eslint-disable-next-line
  }, [])

  const filter_aendern = (filter) => {
    localStorage.setItem("WEBPDB_FILTER", filter)
    setFilter(filter);
  }
  const searchFilter_aendern = (filter) => {
    setSearchFilter(filter)

  }
  const documentCb = (response) => {
    if (response.status === 200) {
      if (response.data.document) {
        setDocuments(response.data.document);
      } else {
        setDocuments([]);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  if (isLoading) {
    return <LoadingComponent />
  }
  const fitlerByType = (element) => {
    var result;
    switch (filter) {
      case "O":
        result = element.status === "offen";
        break;
      case "B":
        result = element.status === "bestätigt";
        break;
      case "A":
        result = true;
        break;
      default:
        result = false;
        break;
    }
    return (result);
  }

  const dataRequest = (documents.filter(element => fitlerByType(element)).length > 0) ? documents.filter(element => fitlerByType(element)).map((element) => {
    if (searchFilter !== "" && !element.bez.includes(searchFilter)) {
      return
    }
    var statusText = ""
    if (element.status === "offen") {
      statusText = t("offen")
    }
    if (element.status === "bestätigt") {
      statusText = t("bestätigt")
    }
    switch (element.status) {
      case "offen":
        return (
          <TableRow style={{ cursor: 'pointer' }}
            onClick={() => navigate("/WEBPDB/pflichtdoc/confirm/" + element.key)}
            hover
          >
            <TableCell>{element.bez}</TableCell>
            <TableCell>{statusText}</TableCell>
          </TableRow>
        );
      case "bestätigt":
        return (
          <TableRow style={{ cursor: 'pointer' }}
            onClick={() => navigate("/WEBPDB/pflichtdoc/details/" + element.key)}
            hover
          >
            <TableCell>{element.bez}</TableCell>
            <TableCell>{statusText}</TableCell>
          </TableRow>
        );
      default:
        return (
          <TableRow>
            <TableCell>{element.bez}</TableCell>
            <TableCell>{statusText}</TableCell>
          </TableRow>
        );
    }
  })
    :
    <TableRow>
      <TableCell colSpan={3}>
        <Typography variant="body1">{t("Es wurden keine offenen Pflichtdokumente gefunden")}</Typography>
      </TableCell>
    </TableRow>
    ;
  if (window.cordova) {
    return (
      <Fragment>
        <Box p={2}>
          <TextField
            select
            variant="outlined"
            label={t("Filter")}
            value={filter}
            onChange={(event) => filter_aendern(event.target.value)}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          >
            <MenuItem value="O">{t("offen")}</MenuItem>
            <MenuItem value="B">{t("bestätigt")}</MenuItem>
            <MenuItem value="A">{t("alle")}</MenuItem>
          </TextField>
           <TextField

            variant="outlined"
            label={t("Suchen")}
            value={searchFilter}
            onChange={(event) => searchFilter_aendern(event.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          ></TextField>
        </Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("Bezeichnung")}</TableCell>
                <TableCell>{t("Status")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataRequest}
            </TableBody>
          </Table>
        </TableContainer>
      </Fragment>
    );
  } else {
    return (
      <Page>
        <Layout>
          <TextField
            select
            variant="outlined"
            label={t("Filter")}
            value={filter}
            onChange={(event) => filter_aendern(event.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          >
            <MenuItem value="O">{t("offen")}</MenuItem>
            <MenuItem value="B">{t("bestätigt")}</MenuItem>
            <MenuItem value="A">{t("alle")}</MenuItem>
          </TextField>
          <TextField

            variant="outlined"
            label={t("Suchen")}
            value={searchFilter}
            onChange={(event) => searchFilter_aendern(event.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          ></TextField>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("Bezeichnung")}</TableCell>
                  <TableCell>{t("Status")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataRequest}
              </TableBody>
            </Table>
          </TableContainer>
        </Layout>
      </Page>
    );
  }
}
export default MandatoryDocument;
